import axios from "axios";
const jsonConfig = require("../../Config.json");
const updateAssignedRecruitmentLeader = async(payload) => {
    try
    {
        const response = await axios.post(
            `${jsonConfig.apiUrl}updateAssignedRecruitmentLeader`, payload,
            {
                headers: {
                    "x-functions-key": jsonConfig.key,
                }
            }
        );
        return Promise.resolve(response);
    }
    catch(error)
    {
        return Promise.reject(error);
    }
}
export default updateAssignedRecruitmentLeader